import React from "react";
import { SharedSchedulesContext } from "@/context/SharedSchedulesContext";

export default function useSharedSchedules() {
  return React.useContext(SharedSchedulesContext);
}
